import React from 'react'
import styled from 'react-emotion'

const Buttons = styled('div')`
  display: flex;
  justify-content: ${props => props.count === 1 ? 'flex-end' : 'space-between'};
  margin-top: 10px;
  .btn {
    width: calc(50% - 10px);
    margin-bottom: 10px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    .btn {
      width: 100%;
    }
  }
`

export default ({ children }) => (
  <Buttons count={React.Children.count(children)}>
    {children}
  </Buttons>
)

